// ============================================================================
// Motor de custo da Shopee — taxas oficiais Brasil CNPJ, vigência 01/03/2026.
// Fonte de verdade: docs/REGRAS-OFICIAIS-CUSTO.md (Central do Vendedor, art. 26839).
//
//   Custo do vendedor = comissão% × preço + taxa fixa da faixa.
//   A comissão JÁ inclui a taxa de transação. Frete embutido (sem custo separado).
//
//   Valor do item     | Comissão | Taxa fixa / item
//   ------------------|----------|------------------
//   < R$ 8,00         |   20%    | 50% do preço
//   R$ 8 – 79,99      |   20%    | R$ 4,00
//   R$ 80 – 99,99     |   14%    | R$ 16,00
//   R$ 100 – 199,99   |   14%    | R$ 20,00
//   ≥ R$ 200          |   14%    | R$ 26,00
//
//   ⚠️ Em degraus: ao cruzar R$80 a comissão CAI (20%→14%) mas a taxa fixa
//   SALTA (R$4→R$16). Não usar flat 20%+R$4 (erra a partir de R$80).
// ============================================================================

export const ShopeeTables = {
    limiarFixa: 8,                 // R$: abaixo disso, taxa = 50% do preço
    // breakpoints onde comissão/taxa fixa mudam (usado pelo solver inverso)
    breaks: [0.01, 8, 80, 100, 200, Infinity],
};

export const ShopeeEngine = {
    // Comissão (%) por faixa de preço.
    comissaoPct(preco) {
        return preco < 80 ? 20 : 14;
    },

    // Taxa fixa por item (R$) por faixa de preço.
    taxaFixaItem(preco) {
        if (preco < 8) return preco * 0.5;
        if (preco < 80) return 4;
        if (preco < 100) return 16;
        if (preco < 200) return 20;
        return 26;
    },

    // Custo total da Shopee para um preço dado (forward).
    calcular(input) {
        const comm = this.comissaoPct(input.preco);
        const comissao = input.preco * comm / 100;
        const fixa = this.taxaFixaItem(input.preco);
        const custoShopee = comissao + fixa;
        return { comissao, comissaoPct: comm, fixa, custoShopee, carga: custoShopee / input.preco };
    }
};
